import dayjs from 'dayjs';

const year = new Date().getFullYear();

export const quarterData = [
  { label: `${year}Q1`, value: `${year}Q1` },
  { label: `${year}Q2`, value: `${year}Q2` },
  { label: `${year}Q3`, value: `${year}Q3` },
  { label: `${year}Q4`, value: `${year}Q4` },
];

export const getQTDList = (beginDate = new Date()) => {
  const nowYear = dayjs().year();
  const nowQuarter = dayjs().quarter();
  let curYear = dayjs(beginDate).year();
  let curQuarter = dayjs(beginDate).quarter();
  const quarterList = [];
  while(curYear < nowYear) {
    while(curQuarter <= 4) {
      quarterList.push(`${curYear}Q${curQuarter}`);
      curQuarter += 1;
    }
    curYear += 1;
    curQuarter = 1;
  }
  if (curYear === nowYear) {
    while(curQuarter <= nowQuarter) {
      quarterList.push(`${curYear}Q${curQuarter}`);
      curQuarter += 1;
    }
  }
  return quarterList.reverse().map((v) => ({ label: v, value: v }));
};

export default {
  quarterData,
};
